<svg class="svg-24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M19.1016 12.2598H5.10156" stroke="#2E3B4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.1016 19.2598L5.10156 12.2598L12.1016 5.25977" stroke="#2E3B4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>